import PropTypes from 'prop-types'

// Internal components
import Button from '../Button/Button'
import LazyImage from '../LazyImage/LazyImage'
import Svg from '../Svg/Svg'

const ChecklistFigure = (props) => {
  const { figure, title, description, listItems, button, reversed, modifiers } = props
  const textContent = description ? description.replace(/<\/?p[^>]*>/g, '') : false

  const createMarkup = (copy) => ({ __html: copy })

  return (
    <div className={`ChecklistFigure ${reversed ? 'is-reversed' : ''} ${modifiers.join(' ')}`}>
      <div className="ChecklistFigure-content">
        <div className="ChecklistFigure-graphic">
          {figure && (
            <LazyImage
              image={figure.image}
              alt={figure.alt}
              sizes={'(min-width: 1440px) 800px, (min-width: 460px) 50vw, 100vw'}
              modifiers={['LazyImage--pageCover']}
            />
          )}
        </div>
        <div className="ChecklistFigure-copyWrapper">
          <div className="ChecklistFigure-copy">
            {title && <h2 className="ChecklistFigure-title">{title}</h2>}
            {textContent && (
              <div className="ChecklistFigure-description" dangerouslySetInnerHTML={createMarkup(textContent)} />
            )}
            <ul className="ChecklistFigure-list">
              {listItems &&
                listItems.map((listItem, index) => {
                  return (
                    <li className="ChecklistFigure-item" key={`ChecklistFigure-item--${index}`}>
                      <Svg id="icon-check" modifiers={['ChecklistFigure-itemIcon']} />
                      {listItem}
                    </li>
                  )
                })}
            </ul>
            {button && Array.isArray(button) ? (
              <div className="ChecklistFigure-buttonGroup">
                {button.map((item, index) => {
                  return <Button key={`${item.label}-${index}`} {...item} />
                })}
              </div>
            ) : (
              button && <Button {...button} />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

ChecklistFigure.defaultProps = {
  modifiers: []
}

ChecklistFigure.propTypes = {
  figure: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
  listItems: PropTypes.array,
  button: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.bool]),
  reversed: PropTypes.bool,
  modifiers: PropTypes.array
}

export default ChecklistFigure
